module.exports = __webpack_public_path__ + "img/leftBar.45c6509b.png";